import { render, staticRenderFns } from "./CreateStagingModal.vue?vue&type=template&id=fe360e3e&scoped=true&"
import script from "./CreateStagingModal.vue?vue&type=script&lang=js&"
export * from "./CreateStagingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe360e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe360e3e')) {
      api.createRecord('fe360e3e', component.options)
    } else {
      api.reload('fe360e3e', component.options)
    }
    module.hot.accept("./CreateStagingModal.vue?vue&type=template&id=fe360e3e&scoped=true&", function () {
      api.rerender('fe360e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Staging/CreateStagingModal/CreateStagingModal.vue"
export default component.exports